import PropTypes from 'prop-types'
import React from 'react'
import { findDOMNode } from 'react-dom'
import { DropTarget } from 'react-dnd'
import { FormattedMessage } from 'react-intl'
import Content from '../../Content'
import ElementContentIcon from '../../ContentIcon'
import {
  ContentHeader,
  ContentTitle,
  ContentIcon,
  ContentBody,
  ContentButton,
  ContentIconGroup
} from 'components/Content'
import {
  ToggleModal
} from 'components/Modal'
import KanBoIcon from 'components/KanBoIcon'
import userDragType from 'components/User/dragType'
import CardUser from './User'
import UsersAction from 'components/CardActions/Users'
import Observers from './Observers'
import Visitors from './Visitors'
import classes from './Users.module.scss'
import { withBoardPermission } from 'dataProviders/Board'

const draggableOverStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: '#fff',
  zIndex: 2,
  opacity: 0.5
}

export class Users extends React.Component {
  static propTypes = {
    cardContext: PropTypes.object.isRequired,

    permission: PropTypes.object.isRequired,

    connectUserDropTarget: PropTypes.func.isRequired,
    isUserOver: PropTypes.bool.isRequired,
    canDropUser: PropTypes.bool.isRequired,
    connectResponsibleUserDropTarget: PropTypes.func.isRequired,
    isResponsibleUserOver: PropTypes.bool.isRequired,
    canDropResponsibleUser: PropTypes.bool.isRequired,

    isArchived: PropTypes.bool.isRequired,
    responsible: PropTypes.number,
    users: PropTypes.array.isRequired,

    requestAddUser: PropTypes.func.isRequired,
    requestRemoveUser: PropTypes.func.isRequired,
    requestMakeUserResponsible: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      showModal: false
    }

    this.handleRef = this.handleRef.bind(this)
    this.handleAddUser = this.handleAddUser.bind(this)
    this.handleRemoveUser = this.handleRemoveUser.bind(this)
    this.handleModalToggle = this.handleModalToggle.bind(this)
    this.handleAddUserClick = this.handleAddUserClick.bind(this)
  }

  handleRef (ref) {
    this.props.connectUserDropTarget(findDOMNode(ref))
  }

  handleAddUser (user) {
    this.props.requestAddUser({
      cardId: this.props.cardContext.id,
      userId: user.id
    })
  }

  handleRemoveUser (user) {
    this.props.requestRemoveUser({
      cardId: this.props.cardContext.id,
      userId: user.id
    })
  }

  handleModalToggle (show) {
    if (show === false) {
      this.setState({ showModal: false })
    }
  }

  handleAddUserClick () {
    this.setState({
      showModal: true
    })
  }

  render () {
    const {
      isUserOver,
      canDropUser,
      connectResponsibleUserDropTarget,
      isResponsibleUserOver,
      canDropResponsibleUser,
      isArchived,
      permission,
      responsible,
      users
    } = this.props
    const {
      showModal
    } = this.state

    return (
      <Content
        ref={this.handleRef}
      >
        {(isUserOver && canDropUser) && <span style={draggableOverStyle} />}        
        <ToggleModal
          backdrop
          attachClickHandler={false}
          show={showModal}
          onToggle={this.handleModalToggle}
          attachment='top left'
          targetAttachment='bottom left'
          constraints={[
            {
              to: 'window',
              pin: true
            }
          ]}
        >
          <ContentHeader>
            <ElementContentIcon>
              <KanBoIcon name='kanbo-24-members' />
            </ElementContentIcon>
            <ContentTitle>
              <FormattedMessage id='CARD_MEMBERS' />
            </ContentTitle>
            <ContentIconGroup>
              <Observers />
              <Visitors />
            </ContentIconGroup>
          </ContentHeader>
          <div className={classes.modalWrapper}>
            <div className={classes.modal}>
              <UsersAction
                responsible={responsible}
                users={users}
                onAddUser={this.handleAddUser}
                onRemoveUser={this.handleRemoveUser}
              />
            </div>
          </div>
        </ToggleModal>
        {responsible &&
          <ContentBody style={{ paddingLeft: 10, paddingRight: 10 }}>
            <div className={classes.usersWrapper}>
              {connectResponsibleUserDropTarget(
                <div className={classes.responsibleUserWrapper}>
                  <CardUser
                    id={responsible}
                    avatar
                    defaultMenu
                    presence
                    size={60}
                    isResponsible
                    isArchived={isArchived}
                    permission={permission}
                    isLastMember={users.length === 0}
                  />
                  {(isResponsibleUserOver && canDropResponsibleUser) && <span style={draggableOverStyle} />}
                </div>
              )}
              {users.length > 0 &&
                <div className={classes.usersContainer}>
                  {users.map(userId =>
                    <CardUser
                      key={userId}
                      id={userId}
                      avatar
                      defaultMenu
                      presence
                      isArchived={isArchived}
                      permission={permission}
                      isLastMember={users.length === 0}
                    />
                  )}
                </div>
              }
            </div>
          </ContentBody>
        }
        {(!isArchived && permission.member) &&
          <ContentButton
            onClick={this.handleAddUserClick}
          >
            <ContentIcon>
              <KanBoIcon name='kanbo-16-plus' />
            </ContentIcon>
            <ContentTitle>
              <FormattedMessage id='USERS_ADD' />
            </ContentTitle>
          </ContentButton>
        }
      </Content>
    )
  }
}

const userDropTarget = {
  canDrop (props, monitor) {
    const { permission, responsible, users } = props
    const { id: userId } = monitor.getItem()

    return (
      permission.member &&
      responsible !== userId &&
      users.indexOf(userId) === -1
    )
  },

  drop (props, monitor) {
    const { cardContext, requestAddUser } = props
    const { id: userId } = monitor.getItem()

    requestAddUser({
      cardId: cardContext.id,
      userId
    })
  }
}

const responsibleUserDropTarget = {
  canDrop (props, monitor) {
    const { permission, responsible, users } = props
    const { id: userId } = monitor.getItem()

    return (
      permission.member &&
      responsible !== userId &&
      users.indexOf(userId) !== -1
    )
  },

  drop (props, monitor) {
    const { cardContext, requestMakeUserResponsible } = props
    const { id: userId } = monitor.getItem()

    requestMakeUserResponsible({
      cardId: cardContext.id,
      userId
    })
  }
}

export default
withBoardPermission(
  DropTarget(userDragType, userDropTarget, (connect, monitor) => ({
    connectUserDropTarget: connect.dropTarget(),
    isUserOver: monitor.isOver(),
    canDropUser: monitor.canDrop()
  }))(
    DropTarget(userDragType, responsibleUserDropTarget, (connect, monitor) => ({
      connectResponsibleUserDropTarget: connect.dropTarget(),
      isResponsibleUserOver: monitor.isOver(),
      canDropResponsibleUser: monitor.canDrop()
    }))(Users)
  )
)
